module.exports = __webpack_public_path__ + "static/media/map-marker-green.5a3c2ce5.svg";